import React, { useState, useEffect, useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { AgGrid } from '../AgGrid';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { getOrdersColumnDefinitions } from '../../helpers';
import RequestNewOrdersButton from '../RequestNewOrdersButton';
import { BulkAssignDialog } from '../BulkAssignDialog';
import { AppContext } from '../../AppContext';
import { bulkAssignOrdersToQa } from '../../services';
import ROLES, { hasPermission } from '../../helpers/roles';

// SERVICES
import { getQaUserOptions } from '../../services';

const styles = theme => ({});

export const QaOrdersGrid = withRouter(
  withStyles(styles)(props => {
    const {
      state: { roles },
    } = useContext(AppContext);

    const isAdmin = hasPermission([ROLES.ADMIN], roles);

    const { showCanceledOrdersOnly } = props;
    const columnDefinitions = getOrdersColumnDefinitions('qa', 'admin', isAdmin);
    const [showGrid, setShowGrid] = useState(true);

    const [showBulkEditDialog, setShowBulkEditDialog] = useState(false);
    const [bulkEditRowData, setBulkEditRowData] = useState([]);
    const [dialogValues, setDialogValues] = useState({
      qaId: null,
    });
    const [qaUserOptions, setQaUserOptions] = useState(null);
    const [gridKey, setGridKey] = useState(new Date().getTime());

    const gridOptions = {
      // detailCellRendererParams,
      // masterDetail: true,
      rowSelection: 'multiple',
    };

    const openBulkEditDialog = rowData => {
      setBulkEditRowData(rowData.map(row => row.orderTicket).sort((a, b) => (a > b ? 1 : -1)));
      setShowBulkEditDialog(true);
    };

    const newOrdersCb = () => {
      setGridKey(new Date().getTime());
    };

    const getQaUserOptionsAsync = async () => {
      try {
        let qaList = await getQaUserOptions();
        setQaUserOptions(qaList);
      } catch (error) {
        console.log(error);
      }
    };

    const handleBulkAssignDialogClose = shouldRefetch => {
      setShowBulkEditDialog(false);
      
      if (shouldRefetch) {
        setGridKey(new Date().getTime());
      }
    };

    useEffect(() => {
      getQaUserOptionsAsync();
    }, []);

    return (
      <div className={classnames('flex-1', 'card', 'border-left-green', 'col-center-center')}>
        {!isAdmin && (
          <div style={{ marginBottom: 15 }}>
            <RequestNewOrdersButton cb={newOrdersCb} />
          </div>
        )}
        <AgGrid
          // force rerender when needed
          key={`qa_orders_grid_${gridKey}`}
          gridData={[]}
          columnDefs={columnDefinitions}
          handleCellClick={evt => props.history.push(`/orders/qa/${evt.data.orderTicket}`)}
          redirectOnClick={true}
          rowClassRules={{
            'row-pastDue': 'data.pastDue === true || data.orderLineStatusLookupCode === "CL-RETURNED"',
          }}
          //'row-pastDue': 'data.orderLineStatusLookupCode === "CL-RETURNED"',
          editOnClick={false}
          gridOptions={gridOptions}
          openBulkEditDialog={isAdmin ? openBulkEditDialog : null}
          useDatasource={true}
          datasourceUrl={'/orders'}
          gridName={showCanceledOrdersOnly ? 'QA_CLOSED_GRID' : 'QA_GRID'}
          defaultFilters={[
            showCanceledOrdersOnly
              ? null
              : {
                  name: 'onHold',
                  model: {
                    filterType: 'text',
                    type: 'notContains',
                    filter: 'HOLD',
                  },
                },
          ].filter(Boolean)}
        />

        <BulkAssignDialog
          {...props}
          onConfirm={bulkAssignOrdersToQa}
          rowData={bulkEditRowData || []}
          personOptions={qaUserOptions}
          personValueField={'qaId'}
          personPlaceholder={'Search for a QA rep'}
          allowBlankAssignment
          blankAssignmentWarningMessage="Submitting without a selected QA rep will unassign the selected orders and return them to the queue. Are you sure you want to continue?"
          show={showBulkEditDialog}
          onClose={handleBulkAssignDialogClose}
          dialogValues={dialogValues}
          setDialogValues={setDialogValues}
        />
      </div>
    );
  }),
);

QaOrdersGrid.propTypes = {
  showCanceledOrdersOnly: PropTypes.bool,
};
